module.exports = __webpack_public_path__ + "static/media/car-cash.53559484.jpg";